var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_c('AboutPageHeader'),_c('OurStory'),_c('FeatureTwo',{attrs:{"bgLight":"bgLight"}}),_c('OurTeam'),_c('FooterWithBg')],1)}
var staticRenderFns = []

export { render, staticRenderFns }